import React from "react";
import { useForm } from 'react-hook-form';

// components
import {  Row, Col, Card, CardBody, Container } from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";
import InputPDF from "components/Input/InputPDF";


export default function ImplantacaoDatasys({ history }) {

    const { handleSubmit } = useForm({ mode: "onBlur" });

    const steps = ['Lojas', 'Usuários', 'Fornecedores', 'Produtos', 'Clientes', 'Importação de Saldo'];
    const [step, set_step] = React.useState(0);
    const handleProximoStep = () => {
        set_step(step + 1);
    }
    const handleStepAnterior = () => {
        set_step(step - 1);
    }

    const onSubmit = (data) => {

    }

    return (
        <>
            <div>
                <Container className="text-center">
                    <ProgressBar stepValue={step} steps={steps} />
                </Container>
                <Card className="card-stats">
                    {step == 0 &&
                        <CardBody>
                            <Row>
                                <Col lg="12">
                                    <h3 id="nome_empresa" className="titulo-consulta">Cadastro de Lojas</h3>
                                    <div className="line-protocolo"></div>
                                </Col>
                            </Row>
                            <Row className="mb-4">                                
                                <Col md="12" lg="12" className="mt-2">
                                    <strong>Selecione o arquivo para importar as lojas no sistema</strong><br/>
                                    <InputPDF height="4rem" width="4rem" name="comprovantePagamento"
                                        image={null}
                                        documento_id={1}>
                                    </InputPDF>
                                </Col>
                            </Row>
                        </CardBody>
                    }
                    {step == 1 &&
                        <CardBody>
                            <Row>
                                <Col lg="12">
                                    <h3 id="nome_empresa" className="titulo-consulta">Cadastro de Usuários</h3>
                                    <div className="line-protocolo"></div>
                                </Col>
                            </Row>
                        </CardBody>
                    }
                    {step == 2 &&
                        <CardBody>
                            <Row>
                                <Col lg="12">
                                    <h3 id="nome_empresa" className="titulo-consulta">Cadastro de Fornecedores</h3>
                                    <div className="line-protocolo"></div>
                                </Col>
                            </Row>
                        </CardBody>
                    }
                    {step == 3 &&
                        <CardBody>
                            <Row>
                                <Col lg="12">
                                    <h3 id="nome_empresa" className="titulo-consulta">Cadastro de Produtos</h3>
                                    <div className="line-protocolo"></div>
                                </Col>
                            </Row>
                        </CardBody>
                    }
                    {step == 4 &&
                        <CardBody>
                            <Row>
                                <Col lg="12">
                                    <h3 id="nome_empresa" className="titulo-consulta">Cadastro de Clientes</h3>
                                    <div className="line-protocolo"></div>
                                </Col>
                            </Row>
                        </CardBody>
                    }
                    {step == 5 &&
                        <CardBody>
                            <Row>
                                <Col lg="12">
                                    <h3 id="nome_empresa" className="titulo-consulta">Importação de Saldo</h3>
                                    <div className="line-protocolo"></div>
                                </Col>
                            </Row>
                        </CardBody>
                    }
                </Card>
            </div>
        </>
    );
}